import React, {useCallback} from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import CBCDialog from 'shared/components/ConfirmationDialog/CBCDialog';
import Footer, {
    CloseEventType,
} from 'shared/components/ConfirmationDialog/Footer';
import {size} from 'shared/Breakpoints';

// Scoped to this dialog only via the marker class below, so CBCDialog and
// Footer (both shared with other modals) stay untouched for other consumers.
const DeleteRoomLayoutDialogGlobalStyle = createGlobalStyle`
    .modal-content:has(.delete-room-layout-dialog-marker) {
        .modal-header {
            background: #fff;
        }

        .modal-header > div {
            color: #000;
        }
    }
`;

const MessageContent = styled.div`
    width: 100%;
    padding: 20px 10px;
    text-align: center;
`;

const StyledFooter = styled(Footer)`
    background: #fff !important;
    justify-content: flex-end;

    @media (max-width: ${size.md}px) {
        justify-content: center;
    }

    .job-button {
        border: 1px solid transparent;
        text-decoration: none !important;

        &:hover {
            border-color: white;
            filter: brightness(0.92);
            text-decoration: none !important;
        }
    }
`;

interface DeleteRoomLayoutDialogProps {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteRoomLayoutDialog = ({
    show,
    onConfirm,
    onCancel,
}: DeleteRoomLayoutDialogProps) => {
    const handleClose = useCallback(
        (event: CloseEventType) => {
            if (event === CloseEventType.OK) {
                onConfirm();
            } else {
                onCancel();
            }
        },
        [onConfirm, onCancel]
    );

    return (
        <>
            <DeleteRoomLayoutDialogGlobalStyle />
            <CBCDialog
                display={show}
                title="Delete Room Layout"
                width="30vw"
                footer={
                    <StyledFooter
                        onClose={handleClose}
                        noButtonText="Cancel"
                        noIcon="Button-Cancel.svg"
                        okButtonText="Yes"
                        okIcon="Options-Delete-White.svg"
                        okButtonClassname="job-button button-danger"
                        reverseOrder
                    />
                }>
                <MessageContent className="delete-room-layout-dialog-marker">
                    <p>Are you sure you want to delete this room layout?</p>
                    <p className="mb-0">
                        Any placeholder models used in this layout will be
                        permanently removed, and products will need to be
                        repositioned. This can&apos;t be undone.
                    </p>
                </MessageContent>
            </CBCDialog>
        </>
    );
};

export default DeleteRoomLayoutDialog;
